module.exports = __webpack_public_path__ + "img/ehs-m.803b50d4.jpg";